import Pusher from 'pusher-js';

export default new Pusher(window.Glide.PUSHER_KEY, {
  cluster: 'us2',
});
